export default __webpack_public_path__ + "static/media/cof_results.e81c97ed.png";